/**
 * indexedDB
 */
import Dexie from "dexie";
import { defaultNav } from "@/assets/nav-data.js";

export const database = new Dexie("myNav");
database.version(1).stores({
  bookmark: "id,name,desc,pid,type,link,icon,sort,createTime",
});

// 初始化默认数据
export const initDefaultData = () => {
  return new Promise((resolve, reject) => {
    database.bookmark
      .count()
      .then((res) => {
        if (res === 0) {
          let navs = processDefaultNavData();
          database.bookmark
            .bulkAdd(navs)
            .then(() => {
              resolve();
            })
            .catch((err) => {
              reject(err);
            });
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
};

//
// 处理默认导航数据
function processDefaultNavData() {
  let navs = [];
  defaultNav.forEach((item, i) => {
    let pid = generateUniqueID();
    navs.push({
      id: pid,
      name: item.name,
      desc: "",
      pid: 0,
      type: 1,
      link: "",
      icon: "",
      sort: i,
      createTime: new Date(),
    });
    item.children.forEach((citem, j) => {
      navs.push({
        id: generateUniqueID(),
        name: citem.name,
        desc: citem.desc,
        pid: pid,
        type: 2,
        link: citem.link,
        icon: citem.icon,
        sort: j,
        createTime: new Date(),
      });
    });
  });
  return navs;
}

// 生成uuid
export const generateUniqueID = () => {
  let uuid = ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
    (
      c ^
      (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
    ).toString(16)
  );
  return uuid;
};
